import { render, staticRenderFns } from "./ViewProductsPricing.vue?vue&type=template&id=a3ab7a20&"
import script from "./ViewProductsPricing.vue?vue&type=script&lang=js&"
export * from "./ViewProductsPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports